"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.csvToList = csvToList;
exports.listToCsv = listToCsv;

var _underscore = require("underscore");

function csvToList(value) {
  if (value) {
    return value.split(',');
  }

  return [];
}

function listToCsv(values) {
  if (values) {
    var nonEmpty = (0, _underscore.filter)(values, function (item) {
      return item !== '';
    });

    if (nonEmpty.length === 0) {
      return null;
    }

    return nonEmpty.join(',');
  }

  return null;
}